module.exports = __webpack_public_path__ + "img/logo-headline65x400.df2e375b.png";